import {Params} from '@angular/router';
import {RangeFilters} from '~shared/models';
import { FilterHandlerParams } from '~app/modules/filters/models/filter-handler-params';


export class RangeFilterHandler {

  private static _instance: RangeFilterHandler;
  public static get instance(): RangeFilterHandler {
    if (!RangeFilterHandler._instance) {
      RangeFilterHandler._instance = new RangeFilterHandler();
    }
    return RangeFilterHandler._instance;
  }

  protected queryParams: Params;

  protected constructor() {
  }

  updateQueryParams(params: Params): void {
    this.queryParams = params;
  }

  apply(range: RangeFilters): FilterHandlerParams {
    const {filter: {options = {}, options_ranges: prevRanges = {}, ...rest} = {}} = this.queryParams || {};
    const filterExist = Object.keys(range)?.[0] in prevRanges;
    const { [Object.keys(range)?.[0]]: omit, ...others } = prevRanges;
    const optionsRanges = filterExist ?
      {options_ranges: {...range, ...others}} :
      {options_ranges: {...range, ...prevRanges}};
    return {params: {filter: {...optionsRanges, options, ...rest}}, config: {resetPaging: true}};
  }

  remove(type: string): FilterHandlerParams {
    const filters = {};
    filters[type] = {from: null, to: null};
    return this.apply(filters);
  }

  reset(): FilterHandlerParams {
    return this.apply({from: null, to: null});
  }
}
